import { create } from "zustand";
import { SearchSlice, createSearchStore } from "./search.store";

interface SearchStoreTypes extends SearchSlice {}

export const useSearchStore = create<SearchStoreTypes>((...args) => ({
	...createSearchStore(...args),
}));
